<template>
  <GenericPlatformAccountBoard platform="xhs" />
</template>
<script setup>
import GenericPlatformAccountBoard from './GenericPlatformAccountBoard.vue'
</script>
